module.exports = __webpack_public_path__ + "resources/img/img_hyper_personal.0492d2ea6a8988ebf9bc04b789de6116.png";